if (!customElements.get('drawer-quick-add-form')) {
  customElements.define(
    'drawer-quick-add-form',
    class DrawerQuickAddForm extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.querySelector('button').addEventListener('click', e => {
          const targetElement = e.currentTarget
          targetElement.innerHTML = `
            <div class="loading__spinner">
              <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          `
          let formData = {
            'items': [{
              'id': parseFloat(this.querySelector('input[name="id"]').value),
              'quantity': 1,
            }],
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            fetch('/?sections=header')
            .then((res) => res.json())
            .then((res) => {
              const parser = new DOMParser()
              const doc = parser.parseFromString(res['header'], 'text/html')
              document.querySelector('.shopping_cart .product_actions').innerHTML = doc.querySelector('.shopping_cart .product_actions').innerHTML
              document.querySelector('.shopping_cart .cart__drawer__items').innerHTML = doc.querySelector('.shopping_cart .cart__drawer__items').innerHTML
              targetElement.innerHTML = `Add to cart`
            })

            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              const totalPrice = cart.total_price;
              updateInstallmentPrice(totalPrice);
            });
          })
          .catch((error) => {
            console.error('Error:', error)
          })
        })
      }
    }
  )
}

document.querySelector('.shopping_cart').addEventListener('click', e => {
  if (e.target.classList.contains('btn--delete')) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'line': parseFloat(e.target.dataset.variantId),
        'quantity': 0,
      })
    })
    .then(response => {
      fetch('/?sections=header')
      .then((res) => res.json())
      .then((res) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(res['header'], 'text/html')
        document.querySelector('.shopping_cart .product_actions').innerHTML = doc.querySelector('.shopping_cart .product_actions').innerHTML
        document.querySelector('.shopping_cart .cart__drawer__items').innerHTML = doc.querySelector('.shopping_cart .cart__drawer__items').innerHTML
      })

      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const totalPrice = cart.total_price;
        updateInstallmentPrice(totalPrice);
      });
    })
    .catch((error) => {
      console.error('Error:', error)
    })
  }
})
  
document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.popup_slider', {
    speed: 1000,
    loop: true,
    spaceBetween: 8,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.popup_slider_wrapper .swiper--button-next',
      prevEl: '.popup_slider_wrapper .swiper--button-prev',
    },
  })
})

// Function to update installment display
function updateInstallmentPrice(totalPrice) {
  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  document.querySelector('.cart-installment3-price').textContent = 'of 3 x ' + FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60-price').textContent = 'Vanaf ' + FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat) + ' p/m';

  document.querySelector('.cart-installment3').textContent = FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60').textContent = FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60-table').innerHTML = `
    <table cellpadding="0" cellspacing="0" style="width: 100%; text-align: center; background: #EAF7F3; border-radius: 0.6rem; border-spacing: 0.5rem; overflow: hidden;">
      <tr>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>12 keer</strong><br><span class="product-table-installment-12">${FoxTheme.Currency.formatMoney((totalPrice / 12).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>18 keer</strong><br><span class="product-table-installment-18">${FoxTheme.Currency.formatMoney((totalPrice / 18).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>24 keer</strong><br><span class="product-table-installment-24">${FoxTheme.Currency.formatMoney((totalPrice / 24).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>36 keer</strong><br><span class="product-table-installment-36">${FoxTheme.Currency.formatMoney((totalPrice / 36).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>60 keer</strong><br><span class="product-table-installment-60">${FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
      </tr>
    </table>
  `;
}
